export function DocumentReducer(state: any, action: any) {
    switch (action.type) {
        case 'setDocuments':
            return {...state, documents: action.documents};
        case 'setLoading':
            return {...state, loading: action.loading};
        default:
            return state;
    }
}